export default "__VITE_ASSET__BR10XZKu__"